'use client';
import { appPublicConfig } from '@/configs/appPublicConfig';
import { H2uCustomError } from '@/shared/components/features/errorPages/H2uCustomError';

export default function RootError() {
  return <H2uCustomError config={appPublicConfig} statusCode={500} />;
}
